import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { graphql, compose } from "react-apollo";

import { useAuthState, useAuthDispatch } from "../Context";
import { notify } from "../generic";
import {
  login,
  register,
  preRegister
} from "../../api/queries/utilisateur.mutations";
import ValidatedEmailForm from "../components/ValidatedEmailForm";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";

function RegisterPage(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handlePreRegister = inputEmail => {
    try {
      let response = _mutatePreRegisterUser(inputEmail); //loginUser action makes the request and handles all the neccessary state changes

      setEmail(inputEmail);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRegister = async settings => {
    try {
      let response = await _mutateRegisterUser(settings); //loginUser action makes the request and handles all the neccessary state changes

      if (!response);
      const { firstName, lastName, email, code, codeToken } = response;

      navigate("/register/");
    } catch (error) {
      console.log(error);
    }
  };

  const _mutateLoginUser = async ({ email, password, validationToken }) => {
    try {
      return props
        .login({
          variables: {
            email,
            password
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.login;

          if (type === "success") {
            dispatch({ type: "REQUEST_LOGIN" });
            const { user } = JSON.parse(details);

            if (user.token) {
              dispatch({ type: "LOGIN_SUCCESS", payload: user });
              localStorage.setItem("currentUser", JSON.stringify(user));

              navigate(`/validate/${validationToken}`);
            }
          } else {
            notify("error", message);
            dispatch({ type: "LOGIN_ERROR", error: message });
          }
        });

      return;
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const _mutateRegisterUser = async ({
    firstName,
    lastName,
    email,
    password,
    denomination,
    siren,
    codePostal,
    ville,
    pays,
    adresse,
    adresseComplement,
    phone
  }) => {
    try {
      return props
        .register({
          variables: {
            firstName,
            lastName,
            email,
            password,
            denomination,
            siren,
            codePostal: String(codePostal),
            ville,
            pays: "France",
            adresse,
            adresseComplement,
            phone: String(phone)
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.register;
          const { validationToken } = JSON.parse(details);

          if (type === "success") {
            return _mutateLoginUser({ email, password, validationToken });
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const _mutatePreRegisterUser = email => {
    try {
      return props
        .preRegister({
          variables: {
            email
          }
        })
        .finally();
    } catch (error) {}
  };

  return (
    <div>
      <div className="sidenav small">
        <div className="login-main-text">
          <h2>Penge</h2>
          <h3>Inscription</h3>
        </div>
      </div>
      <div className="main expanded">
        <div className="register-form">
          {!email && (
            <ValidatedEmailForm handleSubmit={em => handlePreRegister(em)} />
          )}
          {email && (
            <ValidatedRegisterForm
              email={email}
              handleSubmit={handleRegister}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default compose(
  graphql(register, {
    name: "register"
  }),
  graphql(preRegister, {
    name: "preRegister"
  }),
  graphql(login, {
    name: "login"
  })
)(RegisterPage);
